/**
 * Labiarge top-down search drawer, extras injector.
 *
 * Horizon's vendor `search-modal` snippet hard-codes its inner markup, so we
 * can't add brand content (Trending links + Featured imagery) inline without
 * forking the snippet. Instead, snippets/labiarge-search-drawer.liquid emits
 * a <template id="labiarge-search-drawer-template"> in <head>; this module
 * clones its content into the modal's `.predictive-search-form__content` on
 * first paint. Idempotent. Guarded by a data-attribute marker.
 *
 * Visibility (extras vs. predictive results) is handled in CSS via
 * `:has(.search-input:placeholder-shown)`, so no JS state needed.
 */

const TEMPLATE_ID = 'labiarge-search-drawer-template';
const TARGET_SELECTOR = '#search-modal .predictive-search-form__content';
const INSERTED_FLAG = 'labiargeSearchExtrasInserted';

function inject() {
  const template = document.getElementById(TEMPLATE_ID);
  if (!(template instanceof HTMLTemplateElement)) return;

  const target = document.querySelector(TARGET_SELECTOR);
  if (!(target instanceof HTMLElement)) return;
  if (target.dataset[INSERTED_FLAG] === 'true') return;

  // Insert as first child so brand panel sits above Horizon's empty-state list.
  target.prepend(template.content.cloneNode(true));
  target.dataset[INSERTED_FLAG] = 'true';
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', inject, { once: true });
} else {
  inject();
}

// Theme Editor re-renders sections without a full page reload; re-inject if
// the search modal was swapped out.
document.addEventListener('shopify:section:load', inject);
